import { render, staticRenderFns } from "./LikersList.vue?vue&type=template&id=f676627a&scoped=true&"
import script from "./LikersList.vue?vue&type=script&lang=js&"
export * from "./LikersList.vue?vue&type=script&lang=js&"
import style0 from "./LikersList.vue?vue&type=style&index=0&id=f676627a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f676627a",
  null
  
)

export default component.exports